import { useEffect, useState } from "react";

export const useTheme = () => {
  const [theme, setTheme] = useState(() => localStorage.getItem("kicq-theme") || "modern");
  useEffect(() => { localStorage.setItem("kicq-theme", theme); window.scrollTo(0, 0); }, [theme]);
  return [theme, setTheme];
};
